import React from "react";
import {ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Label } from 'recharts';
import {BarChart, Bar } from 'recharts';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';

import UIUtils from '../util/UIUtils';
import Utilities from '../util/Utilities';
import SPUtilities from '../util/SPUtilities';
import ChartUtils from '../util/ChartUtils';
import RespUtils from '../util/RespUtils';

class BaseBarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      responsive: true,
    }

    this.flipResponsive = this.flipResponsive.bind(this);
    this.truncDate = this.truncDate.bind(this);
  }

  flipResponsive() {
    ChartUtils.flipResponsive(this);
  }

  renderBar() {
    // console.log("in render chart: " + (this.props.filter == true));
    // console.log(this.props);

    let width = RespUtils.getResponsiveWidth(this);
    // <Label value={this.props.xAxis} offset={-8} position="insideBottom"/>
    let height = RespUtils.getChartHeight(this);
    let showDataLabel = UIUtils.getShowDataLabel(this, this.props.data, 600);
    let leftMargin = this.getLeftMargin();
    let barSize = null;
    if (this.props.data && this.props.data.length > 60) {
      barSize = 10 * this.props.data.length / 30;
    }

    // console.log("height is: " + height);
     // domain={['auto', 'auto']}7773ba
    return (
      <div>
        <ResponsiveContainer width={width} height={height}>
          <BarChart data={this.props.data} barCategoryGap={2}
                margin={{top: 5, right: 5, left: leftMargin , bottom: 15}}>
            <CartesianGrid vertical={true} horizontal={true} strokeDasharray="3 3"/>
            <XAxis dataKey={this.props.xAxisValueAttr} angle={-10}>
              <Label value={this.props.xAxis} offset={-3} position="insideBottom" />
            </XAxis>
            <YAxis domain={Utilities.getRange(true, this.props.data, this.props.valueAttr)}>
              <Label value={this.props.yAxis} offset={8} position="insideBottomLeft" angle={-90} />
            </YAxis>
            <Tooltip/>
            {showDataLabel && <Bar maxBarSize={50} dataKey={this.props.valueAttr} barSize={barSize} fill="#8884d8" onClick={this.barOnClick} label={{ angle: -90, position: 'center' }}/> }
            {!showDataLabel && <Bar maxBarSize={50} dataKey={this.props.valueAttr} barSize={barSize} fill="#8884d8" onClick={this.barOnClick} /> }
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
  // <CartesianGrid stroke="#eee" strokeDasharray="5 5"/>

  // <p>Data for the latest window (hour or date) is partial. All times are in GMT.</p>

  render () {
  	return (
      <div>
        <b><span align="left">{this.props.title}</span></b>
        <p/>
        <div align="center">
          {this.props.showTotalLabel ? Utilities.getTotalWithLabel(this.props.data, this.props.valueAttr, this.props.totalLabel) : ""}.
          {this.renderBar()}
        </div>
        {ChartUtils.getLandscapeMsg()}
      </div>
    );
  }

  truncDate(val) {
    return ChartUtils.truncDate(val, this.props.chartType, this.props.filter)
  }

  measureText(text: string) {
    if (!this.ctx) {
        this.ctx = document.createElement('canvas').getContext('2d');
        this.ctx.font = '12px "Helvetica Neue"';
    }

    return this.ctx.measureText(text).width;
  }

  getLeftMargin() {
    // const layout = 'vertical';
    // if (layout === 'vertical') {
    // }

    // Horizontal tick labels are clipped on vertical chart.
    // https://github.com/recharts/recharts/issues/1480
    // console.log("this.props.data: ", this.props.data);
    // console.log(this.props.valueAttr);

    let leftMargin = 0;
    for (const value of this.props.data) {
      // console.log(value);
      const textWidth = this.measureText(value[this.props.valueAttr]);
      if (textWidth > leftMargin) {
          leftMargin = textWidth;
      }
    }

    // We have pixel-perfect measurements for the width of our labels, but we also need to account for the default spacing.
    if (leftMargin > 30) {
      leftMargin = Math.max(0, leftMargin - 30);
    }

    // console.log("leftMargin: ", leftMargin);
    return leftMargin;
  }
}

export default BaseBarChart;



// WEBPACK FOOTER //
// ./src/reports/BaseBarChart.js